export default __webpack_public_path__ + "static/media/benefit_4.d2535f08.svg";